
// import React, { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import AppFooter from '../AppFooter';
// import { FaCamera, FaUpload, FaTimes, FaPlus, FaList, FaArrowLeft } from 'react-icons/fa';


// const toAbs = (baseUrl, p) =>
//   !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;

// const pickMemberPhoto = (m) =>
//   m?.photo || m?.image_url || m?.avatar || m?.profileImage || m?.image || m?.path || null;

// export default function MemberList() {
//   const { tenant } = useParams();
//   const navigate = useNavigate();

//   const [members, setMembers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

//   const pageStyle = { background: "#3C3C3C" };

//   useEffect(() => {
//     (async () => {
//       try {
//         const res = await axios.get(`${baseUrl}/api/members/${tenant}/members`);
//         if (res?.data?.success) {
//           const memberData = res.data.members;
//           const sanitized = Array.isArray(memberData?.[0]) ? memberData[0] : memberData;
//           setMembers(Array.isArray(sanitized) ? sanitized : []);
//         } else {
//           setMembers([]);
//           setError(res?.data?.message || "No members found.");
//         }
//       } catch (err) {
//         console.error("Error fetching members:", err);
//         setError("Failed to fetch members. Server may be down.");
//       } finally {
//         setLoading(false);
//       }
//     })();
//   }, [tenant, baseUrl]);

//   // if (loading) return <div className="feed-page"><div className="feed">Loading members…</div></div>;
//   // if (error)   return <div className="feed-page"><div className="feed" style={{color:"#f77"}}>{error}</div></div>;
//   // if (!members.length) return <div className="feed-page"><div className="feed">No members found for this tenant.</div></div>;


//  if (loading) {
//     return (
//       <div className="feed-page" style={pageStyle}>
//         <div className="feed">Loading members…</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="feed-page" style={pageStyle}>
//         <div className="feed" style={{ color: "#f77" }}>{error}</div>
//       </div>
//     );
//   }

//   if (!members.length) {
//     return (
//       <div className="feed-page" style={pageStyle}>
//         <div className="feed">No members found for this tenant.</div>
//       </div>
//     );
//   }

//   return (
//     <div className="feed-page" style={pageStyle}>
//       <div className="feed">
//         {members.map((m) => {
//           const photo = pickMemberPhoto(m);
//           const src = toAbs(baseUrl, photo || "/public/app/default-avatar.png");

//           const goToMember = () => navigate(`/${tenant}/memberDetail`, { state: { member: m } });

//           return (
//             <article key={m.id || m.email} className="feed-card">
//               <div className="feed-card__header" onClick={goToMember} style={{ cursor: "pointer" }}>
//                 <img className="feed-avatar" src={src} alt="" />
//                 <div>
//                   <div className="feed-card__title">
//                     {m?.displayname || m?.name || `${m?.firstname || ""} ${m?.lastname || ""}`}
//                   </div>
//                   {m?.email && <div className="feed-card__sub">{m.email}</div>}
//                 </div>
//               </div>

//               {/* Big profile image like an IG post */}
//               <img
//                 className="feed-media"
//                 src={src}
//                 alt={m?.displayname || "Member"}
//                 onClick={goToMember}
//               />

//               {(m?.bio || m?.phone) && (
//                 <div className="feed-card__body">
//                   {m?.bio && <div>{m.bio}</div>}
//                   {m?.phone && <div className="feed-card__sub">{m.phone}</div>}
//                 </div>
//               )}
//             </article>
//           );
//         })}
//       </div>
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaPlus />,
//             label: 'Add Member',
//             onClick: () => navigate(`/${tenant}/memberAdd`),
//           },
//         ]}
//       />
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import AppFooter from '../AppFooter';
import { FaPlus } from 'react-icons/fa';

const toAbs = (baseUrl, p) =>
  !p ? p : /^https?:\/\//i.test(p) ? p : `${baseUrl}${p.startsWith("/") ? "" : "/"}${p}`;

const pickMemberPhoto = (m) =>
  m?.photo || m?.image_url || m?.avatar || m?.profileImage || m?.image || m?.path || null;

export default function MemberList() {
  const { tenant } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

  const pageStyle = { background: "#3C3C3C" };

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${baseUrl}/api/members/${tenant}/members`);
        if (res?.data?.success) {
          const memberData = res.data.members;
          const sanitized = Array.isArray(memberData?.[0]) ? memberData[0] : memberData;
          setMembers(Array.isArray(sanitized) ? sanitized : []);
        } else {
          setMembers([]);
          setError(res?.data?.message || t("members.noMembersFound"));
        }
      } catch (err) {
        console.error("Error fetching members:", err);
        setError(t("members.fetchError"));
      } finally {
        setLoading(false);
      }
    })();
  }, [tenant, baseUrl, t]);

  if (loading) {
    return (
      <div className="feed-page" style={pageStyle}>
        <div className="feed">{t("members.loadingMembers")}</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="feed-page" style={pageStyle}>
        <div className="feed" style={{ color: "#f77" }}>{error}</div>
      </div>
    );
  }

  if (!members.length) {
    return (
      <div className="feed-page" style={pageStyle}>
        <div className="feed">{t("members.noMembersFound")}</div>
      </div>
    );
  }

  return (
    <div className="feed-page" style={pageStyle}>
      <div className="feed">
        {members.map((m) => {
          const photo = pickMemberPhoto(m);
          const src = toAbs(baseUrl, photo || "/public/app/default-avatar.png");

          const goToMember = () => navigate(`/${tenant}/memberDetail`, { state: { member: m } });

          return (
            <article key={m.id || m.email} className="feed-card">
              <div className="feed-card__header" onClick={goToMember} style={{ cursor: "pointer" }}>
                <img className="feed-avatar" src={src} alt="" />
                <div>
                  <div className="feed-card__title">
                    {m?.displayname || m?.name || `${m?.firstname || ""} ${m?.lastname || ""}`}
                  </div>
                  {m?.email && <div className="feed-card__sub">{m.email}</div>}
                </div>
              </div>

              {/* Big profile image like an IG post */}
              <img
                className="feed-media"
                src={src}
                alt={m?.displayname || t("members.title")}
                onClick={goToMember}
              />

              {(m?.bio || m?.phone) && (
                <div className="feed-card__body">
                  {m?.bio && <div>{m.bio}</div>}
                  {m?.phone && <div className="feed-card__sub">{m.phone}</div>}
                </div>
              )}
            </article>
          );
        })}
      </div>
      <AppFooter
        buttons={[
          {
            icon: <FaPlus />,
            label: t("members.addMember"),
            onClick: () => navigate(`/${tenant}/memberAdd`),
          },
        ]}
      />
    </div>
  );
}